import datetounicode from 'datetounicode'
import datascene from './datascene.js'

import {
  gnaccSubj as accSubj
} from '@bumblehead/gani/src/gnacc.js'

import {
  gnnodeosxGet as nodeosxGet
} from '@bumblehead/gani/src/gnnodeos.js'

// Get a random integer between `min` and `max`.
//
// @param {number} min - min number
// @param {number} max - max number
// @return {int} a random integer
//
const getRandomInt = (min, max) => (
  Math.floor(Math.random() * (max - min + 1) + min))

const getRandomBool = () => (
  Math.random() >= 0.5)

// starting color
//
//   color: "rgba(33, 148, 206)"
//   color: 0x2194ce
//
// random blue, blue 190-210
// random blue green 120-160
const randomblue = () => (
  'rgba(:r, :g, :b, 1)'
    .replace(/:r/, 80)
    .replace(/:g/, getRandomInt(120, 160))
    .replace(/:b/, getRandomInt(190, 210)))

// starting color
//
//   color: "rgba(255, 255, 0)"
//   color: 0xffff000
//
// random blue, blue 190-210
// random blue green 120-160
const randomyellow = () => (
  'rgba(:r, :g, :b, 1)'
    .replace(/:r/, 255)
    .replace(/:g/, getRandomInt(220, 255))
    .replace(/:b/, getRandomInt(0, 50)))

const randomthemecolor = () => (
  getRandomBool() ? randomblue() : randomyellow())

const getrandomposition = () => (
  (Math.random() - 0.5) * 200)

const getrandomrotation = () => (
  Math.random())

const getuuid = () => (
  String(Date.now() + String(Math.floor(100 * Math.random()))))

const getrandomsceneshape = () => ({
  uuid: getuuid(),
  color: randomthemecolor(),
  geometry: [
    100, 100, 100
  ],
  position: [
    getrandomposition(),
    getrandomposition(),
    getrandomposition()
  ],
  rotation: [
    getrandomrotation(),
    getrandomrotation(),
    getrandomrotation()
  ]
})


const getrandomsceneshapes = (numshapes = 0, opt) => {
  const shapes = []

  while (numshapes--) {
    shapes.push(getrandomsceneshape([opt]))
  }

  return shapes
}

const getrandomscene = () => getrandomsceneshapes(3, {})
  .reduce((scene, shape, i) => {
    if (i === 0) {
      // 400, 200, 128
      //
      // where [120, 0] are 'centered'...
      // influences at least one shape to be visible.
      //
      shape.position[0] = getRandomInt(60, 180)
      shape.position[1] = getRandomInt(-20, 20)
    }

    scene.shapedict[shape.uuid] = shape
    scene.sequences.push({
      type: 'shape',
      end: Infinity,
      start: -Infinity,
      isactive: true,
      name: shape.uuid,
      uuid: shape.uuid
    })

    return scene
  }, {
    shapedict: {},
    sequences: []
  })

const $getuuid = (gst, qst) => {
  qst.target = getuuid()

  return qst
}

const $joinstr = (gst, qst) => {
  qst.target = qst.target.join(', ')

  return qst
}

const $getrequrl = (gst, qst) => {
  qst.target = gst.sess.requrl

  return qst
}

// const getshapetype = ([ shapepath ]) => shapepath
const $getshapetype = (gst, qst) => {
  const shapepath = qst.target

  qst.target = shapepath

  return qst
}

const $shaperayover = (/*qst, gst, args*/) => {}

const $getrandomsceneshape = (gst, qst) => {
  qst.target = getrandomsceneshape()

  return qst
}

const $getrandomscene = (gst, qst) => {
  qst.target = getrandomscene()

  return qst
}

const $getseqactionkey = (gst, qst) => {
  const sceneseqnode = qst.target

  if (!sceneseqnode) {
    throw new Error('sceneseqnode not found')
  }

  const actionuuid = accSubj.propget(sceneseqnode, 'uuid')

  qst.target = `/datashapes/${actionuuid}`

  return qst
}

const $getscenenodelabel = (gst, qst) => {
  const sess = gst.sess
  const cfg = gst.cfg
  const baseelem = qst.target
  const { start, type, uuid } = baseelem

  qst.target = datascene.getndscenelabel(
    [{ start, type, uuid }, {}], sess, cfg)

  return qst
}

const $getsceneshapeskeyarr = async (gst, qst) => {
  const graph = gst.graph
  const sess = gst.sess
  const cfg = gst.cfg

  const scenenode = qst.target
  const sceneui = scenenode
    && nodeosxGet(cfg, graph, scenenode)

  qst.target = await sceneui
    .getseqshapekeyarr(sess, cfg, graph, scenenode)

  return qst
}

const $datefmt = async (gst, qst, args) => {
  const date = new Date(qst.target)
  const format = args[0]

  qst.target = datetounicode(date, format)

  return qst
}

export {
  $getrequrl,
  $getuuid,
  $joinstr,
  $getshapetype,
  $getrandomscene,
  $getrandomsceneshape,
  $getseqactionkey,
  $getscenenodelabel,
  $getsceneshapeskeyarr,
  $shaperayover,
  $datefmt
}
